import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';

import { asIs } from 'utils/common';

const MENU_PROPS = { disableScrollLock: true };

/**
 * Simple select component
 * if a label is passed, label is added
 * if error is passed, error text is added
 */
function SimpleSelect({
  optionList,
  label,
  variant,
  width,
  error,
  t,
  ...props
}) {
  return (
    <FormControl style={{ minWidth: width }} variant={variant}>
      {label && <InputLabel id="simple-select-label">{label}</InputLabel>}
      <Select
        variant="outlined"
        {...props}
        error={!!error}
        label={label}
        MenuProps={MENU_PROPS}
        labelId="simple-select-label"
      >
        {optionList.map(item => (
          <MenuItem key={item.value} value={item.value}>
            {t(item.option)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

SimpleSelect.propTypes = {
  t: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  variant: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  optionList: PropTypes.arrayOf(
    PropTypes.shape({
      option: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
};

SimpleSelect.defaultProps = {
  t: asIs,
  error: false,
  label: undefined,
  width: 150,
  variant: 'outlined',
  value: undefined,
  defaultValue: undefined,
};

export default memo(SimpleSelect);
